// extracted by mini-css-extract-plugin
export default {"overlay":"PopUp_overlay__8u9IH","fadeOut":"PopUp_fadeOut__NVvc-","modal":"PopUp_modal__3RcbL","scaleUp":"PopUp_scaleUp__ml7ud","scaleDown":"PopUp_scaleDown__K7hgM"};